import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useParams } from 'react-router-dom';

import { Spinner } from '../../components/spinner';
import { ErrorBoundaryFallback } from '../../components/error-boundary-fallback';
import { ArPyramidValidationProvider } from '../../contexts/ar-pyramid-validation';

export const ArPyramidLayout = () => {
  const { gameCode } = useParams();

  return (
    <ErrorBoundary
      fallbackRender={(props) => <ErrorBoundaryFallback {...props} />}>
      <Suspense fallback={<Spinner />}>
        <ArPyramidValidationProvider gameCode={gameCode!}>
          <Outlet />
        </ArPyramidValidationProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default ArPyramidLayout;
